import { createGlobalStyle } from 'styled-components'

export const FontStyles = createGlobalStyle`
@font-face {
  font-family: "Skolar Sans PE";
  src: url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff2)
      format('woff2'),
  url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Rg_v1.woff)
      format('woff');
  font-weight: 400;
}

@font-face {
  font-family: "Skolar Sans PE";
  src: url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-It_v1.woff2)
      format('woff2'),
  url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-It_v1.woff)
      format('woff');
  font-weight: 400;
  font-style: italic;
}

@font-face {
  font-family: "Skolar Sans PE";
  src: url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Bd_v1.woff2)
      format('woff2'),
  url(https://docs.rferl.org/Branding/CDN/sources/fonts/SkolarSansPE/SkolarSansLatnCyrlCn-Bd_v1.woff)
      format('woff');
  font-weight: 700;
}
`
